// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2vtP_","label":"Labeled_label__398Pw","divider":"Labeled_divider__1ubgT"};